import { IDictionaryStates } from './types';

export enum DictionaryType {
  Cohort = 'cohort',
  Measure = 'measure',
  Event = 'event',
  VirtualEvent = 'virtual-event',
  Field = 'field',
  Filter = 'filter',
  Buckets = 'buckets',
}

export const defaultDictionaryStates: IDictionaryStates = {
  searchTerm: '',
};
